export default {
  selectedElement: '',
  successAction: '',
  configSheet: {},
  allDocuments: {},
  workerData: null,
  companyProfiles: {},
  groupTableFields: [
    { key: 'nombre', label: 'Nombre' },
    { key: 'esLider', label: 'Lider' },
  ],
};
